// extracted by mini-css-extract-plugin
export var cardFancy = "Cards-module--card-fancy--55d06";
export var cardSimple = "Cards-module--card-simple--a5a6f";